import { HashLink } from 'react-router-hash-link';
import './index.css';
import logo from '../../logo.svg'

export default function Navbar() {
  return (
    <div className="nav fit_content">
      <div className="logo">        
        <img src={logo} className="App-logo" alt="logo" />
      </div>    
      <div className='options'>
        <ul>
          <CustomLink name="/#about">About</CustomLink>
          <CustomLink name="/#privacy">Privacy Policy</CustomLink>
          <CustomLink name="/#contact">Contact Us</CustomLink>
        </ul>
      </div>
    </div>
  )
}

function CustomLink({ name, children }) {
  return (
    <li>
      <HashLink smooth to={name}>
        {children}
      </HashLink>
    </li>
  )
}